import { useQueryClient } from '@tanstack/react-query';
import { tourServices } from '../services/tour.service';

export const usePrefetchTours = () => {
  const queryClient = useQueryClient();

  const prefetchNextPage = (filters, totalPages) => {
    const currentPage = parseInt(filters.page);
    if (currentPage < totalPages) {
      const nextFilters = { ...filters, page: String(currentPage + 1) };
      queryClient.prefetchQuery({
        queryKey: ['tours', nextFilters],
        queryFn: () => tourServices.getTours(nextFilters),
      });
    }
  };

  const prefetchPrevPage = (filters) => {
    const currentPage = parseInt(filters.page);
    if (currentPage > 1) {
      const prevFilters = { ...filters, page: String(currentPage - 1) };
      queryClient.prefetchQuery({
        queryKey: ['tours', prevFilters],
        queryFn: () => tourServices.getTours(prevFilters),
      });
    }
  };

  return { prefetchNextPage, prefetchPrevPage };
};
